import { FormObjType } from "DataTypes/Form";

export const ResultForm: FormObjType[] = [
  {
    id: "resultName",
    label: "Result Name",
    placeholder: "Enter Result Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
]

export const ObservationForm: FormObjType[] = [
  {
    id: "observationName",
    label: "Observation Name",
    placeholder: "Enter Observation Name",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "dateTime",
    label: "Observation Date",
    placeholder: "Select Observation Date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "status",
    label: "Status",
    placeholder: "Select Status",
    boxType: "single-select",
    boxSize: 4,
    validatetype: "dropdown",
    required: true,
    enableFormLoad: true,
    dropArr: [
      { id: "Normal", label: "Normal", value: "Normal" },
      { id: "Abnormal", label: "Abnormal", value: "Abnormal" },
      { id: "Unknown", label: "Unknown", value: "Unknown" },
    ],
  },
  {
    id: "observationValue",
    label: "Observation Value",
    placeholder: "Enter Observation Value",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "observationUnit",
    label: "Observation Unit",
    placeholder: "Enter Observation Unit",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
]

// Mock response of the Result Search API, shaped exactly like
// res.data.results. Extra observation objects have been added to each
// result so the listing can be checked with multiple observations.
export const MockResultList: any[] = [
  {
    id: 10,
    code: "624-9",
    codeSystem: "2.16.840.1.113883.6.3",
    codeSystemName: "LOINC",
    name: "PLT",
    status: "ACTIVE",
    producerID: "RL003",
    producername: "Redox Lab WI",
    observations: [
      {
        id: 2,
        code: "624-9",
        codeSystem: "2.16.840.1.113883.6.3",
        codeSystemName: "LOINC",
        name: "Color of Sputum",
        status: "Final",
        interpretation: "Low",
        dateTime: "2012-08-10T14:00:00.000Z",
        value: "11+3/ul",
        units: "Green",
        observationsAltCode: [],
        observationsComments: [],
      },
      {
        id: 3,
        code: "624-10",
        codeSystem: "2.16.840.1.113883.6.3",
        codeSystemName: "LOINC",
        name: "Thickness of Sputum",
        status: "Abnormal",
        interpretation: "High",
        dateTime: "2012-08-11T14:00:00.000Z",
        value: "Thick",
        units: "Scale",
        observationsAltCode: [],
        observationsComments: [],
      },
      {
        id: 4,
        code: "624-11",
        codeSystem: "2.16.840.1.113883.6.3",
        codeSystemName: "LOINC",
        name: "Smell of Sputum",
        status: "Normal",
        interpretation: null,
        dateTime: "2012-08-12T14:00:00.000Z",
        value: "Odourless",
        units: "",
        observationsAltCode: [],
        observationsComments: [],
      },
    ],
  },
  {
    id: 18,
    code: "624-8",
    codeSystem: "2.16.840.1.113883.6.2",
    codeSystemName: "LOINC",
    name: "WBC",
    status: "ACTIVE",
    producerID: "RL002",
    producername: "Redox Lab WI",
    observations: [
      {
        id: 1,
        code: "624-8",
        codeSystem: "2.16.840.1.113883.6.2",
        codeSystemName: "LOINC",
        name: "Color of Sputum",
        status: "Final",
        interpretation: "Low",
        dateTime: "2013-08-10T14:00:00.000Z",
        value: "12+3/ul",
        units: "Green",
        observationsAltCode: [],
        observationsComments: [],
      },
      {
        id: 5,
        code: "624-12",
        codeSystem: "2.16.840.1.113883.6.2",
        codeSystemName: "LOINC",
        name: "WBC Count",
        status: "Abnormal",
        interpretation: "High",
        dateTime: "2013-08-11T14:00:00.000Z",
        value: "25000",
        units: "Cell",
        observationsAltCode: [],
        observationsComments: [],
      },
    ],
  },
  {
    id: 20,
    code: "624-7",
    codeSystem: "2.16.840.1.113883.6.1",
    codeSystemName: "LOINC",
    name: "HGB",
    status: "ACTIVE",
    producerID: "RL001",
    producername: "Redox Lab WI",
    observations: [
      {
        id: 9,
        code: "624-7",
        codeSystem: "2.16.840.1.113883.6.1",
        codeSystemName: "LOINC",
        name: "Color of Sputum",
        status: "Final",
        interpretation: "Low",
        dateTime: "2012-08-10T14:00:00.000Z",
        value: "11+3/ul",
        units: "Green",
        observationsAltCode: [],
        observationsComments: [],
      },
      {
        id: 11,
        code: "624-13",
        codeSystem: "2.16.840.1.113883.6.1",
        codeSystemName: "LOINC",
        name: "Haemoglobin",
        status: "Normal",
        interpretation: null,
        dateTime: "2012-08-13T14:00:00.000Z",
        value: "13.5",
        units: "g/dL",
        observationsAltCode: [],
        observationsComments: [],
      },
      {
        id: 12,
        code: "624-14",
        codeSystem: "2.16.840.1.113883.6.1",
        codeSystemName: "LOINC",
        name: "Haematocrit",
        status: "Unknown",
        interpretation: null,
        dateTime: "2012-08-14T14:00:00.000Z",
        value: "41",
        units: "%",
        observationsAltCode: [],
        observationsComments: [],
      },
    ],
  },
  {
    id: 102,
    code: null,
    codeSystem: null,
    codeSystemName: null,
    name: "Blood Report",
    status: "Abnormal",
    producerID: null,
    producername: null,
    observations: [
      {
        id: 102,
        code: null,
        codeSystem: null,
        codeSystemName: null,
        name: "WBC Count",
        status: "Abnormal",
        interpretation: null,
        dateTime: "2026-08-26T00:00:00.000Z",
        value: "25000",
        units: "Cell",
        observationsAltCode: [],
        observationsComments: [],
      },
      {
        id: 103,
        code: null,
        codeSystem: null,
        codeSystemName: null,
        name: "Platelet Count",
        status: "Normal",
        interpretation: null,
        dateTime: "2026-08-26T00:00:00.000Z",
        value: "210000",
        units: "Cell",
        observationsAltCode: [],
        observationsComments: [],
      },
    ],
  },
]
